module.exports = __webpack_public_path__ + "img/international.7f8bef22.svg";